export default __webpack_public_path__ + "a187cc1abf0b3d77057fc86e0418f7e3.png";